module.exports = __webpack_public_path__ + "img/_fond.b077474c.png";